import React from "react"
import "./sign-up.css"

function SignUp({ show, close }) {
  console.log("close", close)
  return (
    <div className={`e-modal m-modal-overlay ${show ? "show-modal" : ""}`}>
      <div className="e-modal-content">
        {/* <h1>Cook with Reuben Riffel and Dale Steyn</h1>
        <p>Subscribe for the FREE recipe and R100 OFF a Buyfresh recipe box</p> */}
        <iframe
          id="email-sign-up"
          src={`https://cdn.forms-content.sg-form.com/70967138-1735-11ea-a1df-828aa493cef1`}
          width="100%"
        />
        <p className="tees-and-cees">
          By registering to receive this recipe, you give Kin permission to use
          your email in accordance with the Kin Privacy Policy -{" "}
          <a href="https://thekinapp.com/privacy-policy/" target="_blank">
            https://thekinapp.com/privacy-policy/
          </a>
        </p>
        <button
          className="close"
          onClick={() => {
            close()
          }}
        >
          x
        </button>
      </div>
    </div>
  )
}

export default SignUp
